//import { UserExperience } from "../../../auth/pages/profile/scripts/expertise.objects";
import { FormatStringByWordLength, DoArraysOverlap, Split, Join } from "../../../shared/scripts/array-functions";

export class UserDirectoryEntity {

    FirstName: string;
    LastName: string;
    ProjectRole: string;
    Email: string;
    Institution: string = "";
    Affiliations: string = "None Selected";
    StudyAccess: string = "None Selected";

    DisplayName: string;
    SortName: string;
    DisplayEmail: string = "";
    DisplayAffiliation: string = "";
    DisplayStudy: string = "";
    DisplayInstitution: string = "";
    DisplayRole: string = "";
    AffiliationList: string[];
    StudyList: string[];
    HiddenFilter: string = "";

    constructor() { }

    initialize(): void {

        //console.log(this);

        this.DisplayName = this.FirstName + " " + this.LastName;
        this.DisplayName = FormatStringByWordLength(this.DisplayName, 4);
        this.SortName = this.LastName + " " + this.FirstName;

        if (this.Email?.length > 0) {
            //this.DisplayEmail = "<a href='mailto:" + this.Email + "'><span class='nowrap'>" + this.Email.toLowerCase() + "<i class='fa fa-envelope link-icon' aria-hidden='true'></i></span></a>";
            this.DisplayEmail = "<a href='mailto:" + this.Email + "'><span class='nowrap'>" + this.Email.toLowerCase() + "</span></a>";
        }


        //if (this.Affiliation == "SAG") { this.Affiliation = "Scientific Advisory Group (SAG)"; }

        this.AffiliationList = Split(this.Affiliations, "|");
        this.DisplayAffiliation = Join(this.AffiliationList, ", ", true, true);

        this.StudyList = Split(this.StudyAccess, "|");
        this.DisplayStudy = Join(this.StudyList, ", ", true, true);

        this.DisplayInstitution = FormatStringByWordLength(this.Institution, 4);
        this.DisplayRole = FormatStringByWordLength(this.ProjectRole, 4);
    }

    //matchesFilter(affiliation: any, institute: any, country: any, basicScienceExpertise: any, diagnosticExpertise: any, helminthExpertise: any, protozoanExpertise: any, bacteriaExpertise: any): boolean {
    matchesFilter(affiliation: any, study: any, institute: any): boolean {

        //console.log(affiliation, this.Affiliation);

        if (!DoArraysOverlap(affiliation, this.AffiliationList)) { return false; }
        if (!DoArraysOverlap(study, this.StudyList)) { return false; }
        if (!DoArraysOverlap(institute, this.Institution)) { return false; }

        return true;
    }
}